<template>
    <div>
        <div
            :id="'unit' + unit.id + 'p' + page.page"
            class="mt-2"
        >
            <b-card
                no-body
            >
                <template #header>
                    <div class="d-flex align-items-center">
                        <div class="mr-3 font-weight-bold">
                            {{ page.page == 'Extended Reading' ? 'Extended Reading' : 'Page ' + page.page }}
                        </div>
                    </div>
                </template>

                <b-card-body>
                    <div v-if="page_articles && page_articles.length">
                        <div
                            :id="'unit' + unit.id + 'article' + article.id"
                            v-for="(article, index) in page_articles"
                            :key="index"
                            :class="{'mt-1': index > 0}"
                        >
                            <div v-if="article.placeholder_type">
                                <Placeholder
                                    :unit="unit"
                                    :placeholder="article"
                                    @delete="getArticles"
                                />
                            </div>
                            <div v-else>
                                <Article
                                    :publication_id="publication_id"
                                    :publication="publication"
                                    :unit_group="unit_group"
                                    :unit="unit"
                                    :article="article"
                                    :page="page"
                                    :article_position="index"
                                    :page_article_length="page_articles.length"
                                    :disabled="disabled"
                                    :available_standards="available_standards"
                                    :state_grade="state_grade"
                                    @duplicated="getArticles"
                                    @updatedCustomNumber="getArticles"
                                    @updatedOrderNumber="getArticles"
                                    @unlink="unlinkArticle"
                                />
                            </div>
                        </div>
                    </div>

                        <div class="d-flex align-items-center">
                            <div :class="{'flexy': (!page_articles || page_articles && !page_articles.length)}" class="ml-auto">
                                <b-input-group class="pr-3" :size="(page_articles && page_articles.length) ? 'sm' : null" :class="{'mt-2': page_articles && page_articles.length}">
                                    <b-form-input
                                        placeholder="Article ID"
                                        v-model="quickAddArticleID"
                                        :disabled="disabled"
                                    />
                                    <b-input-group-append>
                                        <b-button
                                            variant="outline-success"
                                            @click="quickAddArticle"
                                            :disabled="disabled"
                                        >
                                            Quick add
                                        </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                            </div>

                        <div class="ml-auto"
                             :class="{'flexy': (!page_articles || page_articles && !page_articles.length)}">
                            <b-dropdown
                                variant="outline-primary"
                                :class="{'mt-2': page_articles && page_articles.length}"
                                :size="(page_articles && page_articles.length) ? 'sm' : null"
                                :menu-class="(!page_articles || page_articles && !page_articles.length) ? 'w-100' : null"
                                :block="!page_articles || page_articles && !page_articles.length"
                                :right="(page_articles && page_articles.length) ? true : false"
                                dropup
                                :disabled="disabled"
                            >
                                <template #button-content>
                                    <font-awesome-icon :icon="['fad', 'plus-square']"/>
                                    Add Item
                                </template>
                                <b-dropdown-item @click="confirmCreateArticle">
                                    <font-awesome-icon :icon="['fad', 'plus-square']" class="text-success" fixed-width/>
                                    Create Article
                                </b-dropdown-item>

                                <b-dropdown-item v-if="publication.is_trunk" @click="addArticleToTrunk">
                                    <font-awesome-icon :icon="['fad', 'plus-square']" class="text-primary" fixed-width/>
                                    Add Branch Article To Trunk
                                </b-dropdown-item>
                                <b-dropdown-item v-if="publication.is_trunk" @click="addTrunkArticleToTrunk">
                                    <font-awesome-icon :icon="['fad', 'plus-square']" class="text-warning" fixed-width/>
                                    Add Trunk Article To Trunk
                                </b-dropdown-item>
                                <b-dropdown-item v-else @click="addArticleToBranch">
                                    <font-awesome-icon :icon="['fad', 'plus-square']" class="text-primary" fixed-width/>
                                    Add Trunk Article
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </b-card-body>

            </b-card>


            <article-picker-modal
                v-model="show_article_picker_modal"
                :unit="unit"
                :page="page"
                :page_articles="page_articles"
                :type="type"
                :trunkArticlesOnly="searching_trunk_articles_only"
                :publication="publication"
                @link="linkArticleToPage"
                @unlink="unlinkArticleFromPage"
                @relink="linkArticleToDifferentPage"
                @hide="hideArticlePicker"
                @Trunklink="linkTrunkArticleToPage"
            />

            <copy-te-modal
                v-model="show_copy_te_modal"
                @copy="copyTe"
                @hide="hideCopyTeModal"
            />

        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/css/_colors';

.extended-reading {
    .card {
        border-color: $purple;

        .card-header {
            background-color: $purple;
            color: $white;
        }
    }
}

.flexy {
    flex: 1;
}
</style>

<script>
import VueSticky from 'vue-sticky'
import VueScrollTo from 'vue-scrollto'

import {mapState} from 'vuex'

import Article from '@/components/article/Index'
import Placeholder from '@/components/unit/layout/Placeholder'
import ArticlePickerModal from '@/components/modals/unit/ArticlePickerModal'
import CopyTeModal from '@/components/modals/unit/CopyTeModal'

export default {
    data: () => ({
        type: null,
        searching_trunk_articles_only: false,
        show_article_picker_modal: false,
        show_copy_te_modal: false,
        quickAddArticleID: null,
    }),
    props: [
        'publication_id',
        'publication',
        'unit_group',
        'unit',
        'page',
        'disabled',
        'available_standards',
        'state_grade',
    ],
    components: {
        Article,
        Placeholder,
        ArticlePickerModal,
        CopyTeModal
    },
    directives: {
        'sticky': VueSticky,
    },
    computed: {
        ...mapState({}),
        page_articles() {
            let page_articles = []

            _.forEach(this.unit.articles, article => {
                if (article.page == this.page.page) {
                    page_articles.push(article)
                }
            })
            return page_articles
        }
    },
    methods: {
        getArticles() {
            return new Promise((resolve, reject) => {
                this.axios.get('/api/units/articles/' + this.unit.id)
                    .then(response => {
                        let articles = []

                        if (response.data) {
                            articles = response.data
                            articles = _.orderBy(articles, 'order_number')
                            articles = _.orderBy(articles, 'page')
                            articles = _.uniqBy(articles, 'unit_page_slot_id')
                        }

                        this.$set(this.unit, 'articles', articles)

                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        confirmCreateArticle() {
            if (this.publication.is_trunk != 1) {
                this.$swal({
                    html: 'This Article will only appear in this Publication and Week',
                    showCancelButton: true,
                    confirmButtonText: 'Create Article',
                    confirmButtonColor: '#E67E22',
                    cancelButtonText: 'Cancel',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.createArticle();
                    }
                })
            } else {
                this.createArticle();
            }
        },
        createArticle() {
            this.axios.post('/api/units/create_article/' + this.unit.id, {
                page: this.page.page,
                language: this.publication.language
            })
                .then(response => {
                    let article = null

                    if (response.data) {
                        article = response.data
                    }

                    this.getArticles()
                        .then(() => {
                            let uri = null

                            if (
                                this.unit &&
                                article
                            ) {
                                uri = '#unit' + this.unit.id + 'article' + article.id

                                VueScrollTo.scrollTo(uri, 0, {
                                    offset: -144
                                })
                            }
                        })
                })
        },
        addArticle() {
            // this.filters.push('article')
            this.type = 'article'
            this.searching_trunk_articles_only = false;
            this.show_article_picker_modal = true
        },
        addArticleToTrunk() {
            this.type = 'article'
            this.searching_trunk_articles_only = false;
            this.show_article_picker_modal = true
        },
        addTrunkArticleToTrunk() {
            this.type = 'article'
            this.searching_trunk_articles_only = true;
            this.show_article_picker_modal = true
        },
        addArticleToBranch() {
            this.type = 'article'
            this.searching_trunk_articles_only = true;
            this.show_article_picker_modal = true
        },
        quickAddArticle() {
            this.linkArticleToPage({id: this.quickAddArticleID})
            this.quickAddArticleID = null
        },
        createActivity() {
            this.axios.post('/api/units/create_article/' + this.unit.id, {
                is_activity: true,
                page: this.page.page,
                language: this.publication.language
            })
                .then(() => {
                    this.getArticles()
                })
        },
        addActivity() {
            this.type = 'activity'

            this.show_article_picker_modal = true
        },
        linkArticleToPage(article) {
            let old_pub_id = article.publication_id;
            if (this.publication.is_trunk) {
                this.axios.post('/api/articles/duplicate/' + article.id, {
                    old_publication_id: old_pub_id,
                    new_publication_id: this.publication.id,
                    old_unit_id: article.week_id,
                    new_unit_id: this.unit.id,
                    page: this.page.page,
                    publication_is_trunk: this.publication.is_trunk
                })
                    .then(() => {
                        this.getArticles()
                            .then(() => {
                                let uri = null

                                if (
                                    this.unit &&
                                    article
                                ) {
                                    uri = '#unit' + this.unit.id + 'article' + article.id

                                    VueScrollTo.scrollTo(uri, 0, {
                                        offset: -144
                                    })
                                }
                            })

                        this.show_article_picker_modal = false
                    })
            } else {
                this.axios.post('/api/units/add_article/' + this.unit.id, {
                    article_id: article.id,
                    page: this.page.page
                })
                    .then(() => {
                        this.getArticles()
                            .then(() => {
                                let uri = null

                                if (
                                    this.unit &&
                                    article
                                ) {
                                    uri = '#unit' + this.unit.id + 'article' + article.id

                                    VueScrollTo.scrollTo(uri, 0, {
                                        offset: -144
                                    })
                                }
                            })

                        this.show_article_picker_modal = false
                    })
            }
        },

        linkTrunkArticleToPage(article) {
            let trunk_to_trunk = false;
            if (article.is_trunk == 1 && this.publication.is_trunk == 1) {
                this.$swal({
                    title: 'Link Article (Same ID) or Create Duplicate (New ID)',
                    showCancelButton: true,
                    showCloseButton: true,
                    confirmButtonText: 'New ID',
                    confirmButtonColor: '#2196F3',
                    cancelButtonText: 'Same ID',
                    cancelButtonColor: '#E91E63',
                    cancelButtonClass: 'text-white',
                    reverseButtons: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                }).then((result) => {
                    if (result.value) {
                        this.createAndLinkDuplicateTrunkArticle(article);
                    } else if (result.dismiss === 'cancel') {
                        this.linkExistingTrunkArticle(article);
                    }
                });
            } else {
                this.createAndLinkDuplicateTrunkArticle(article);
            }
        },
        linkExistingTrunkArticle(article) {
            //articles/copy_trunk_to_trunk/{article_id}
            let old_pub_id = article.publication_id;
            this.axios.post('/api/articles/copy_trunk_to_trunk/' + article.id, {
                old_publication_id: old_pub_id,
                new_publication_id: this.publication.id,
                new_unit_id: this.unit.id,
                page: this.page.page
            })
                .then(() => {
                    this.getArticles()
                        .then(() => {
                            let uri = null

                            if (
                                this.unit &&
                                article
                            ) {
                                uri = '#unit' + this.unit.id + 'article' + article.id

                                VueScrollTo.scrollTo(uri, 0, {
                                    offset: -144
                                })
                            }
                        })
                    this.show_article_picker_modal = false
                });
        },
        createAndLinkDuplicateTrunkArticle(article) {
            let old_pub_id = article.publication_id;
            this.axios.post('/api/articles/duplicate/' + article.id, {
                old_publication_id: old_pub_id,
                new_publication_id: this.publication.id,
                old_unit_id: article.week_id,
                new_unit_id: this.unit.id,
                page: this.page.page,
                publication_is_trunk: this.publication.is_trunk
            })
                .then(() => {
                    this.getArticles()
                        .then(() => {
                            let uri = null

                            if (
                                this.unit &&
                                article
                            ) {
                                uri = '#unit' + this.unit.id + 'article' + article.id

                                VueScrollTo.scrollTo(uri, 0, {
                                    offset: -144
                                })
                            }
                        })
                    this.show_article_picker_modal = false
                });
        },
        unlinkArticleFromPage(article) {
            let unlinkable_article = {}
            let message = null

            _.forEach(this.unit.articles, unit_article => {
                if (
                    article.article_id && article.article_id == unit_article.article_id ||
                    unit_article.article_id == article.id
                ) {
                    unlinkable_article = unit_article
                }
            })

            if (
                article.title &&
                unlinkable_article.page
            ) {
                message = 'Are you sure you want to unlink <strong>' + article.title + '</strong> from page <strong>' + unlinkable_article.page + '</strong>?'
            } else {
                message = 'Are you sure you want to unlink this article?'
            }

            this.$swal({
                html: message,
                showCancelButton: true,
                confirmButtonText: 'Unlink Article',
                confirmButtonColor: '#E67E22',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.unlinkArticle(unlinkable_article)
                }
            })
        },
        copyTe() {
            this.show_copy_te_modal = false
        },
        unlinkArticle(unlinkable_article, is_moved = 0) {
            this.axios.post('/api/units/remove_item_from_page/' + unlinkable_article.unit_page_slot_id, {is_moved: is_moved})
                .then(() => {
                    this.getArticles()
                })
        },
        linkArticleToDifferentPage(article) {
            let relinkable_article = {}

            _.forEach(this.unit.articles, unit_article => {
                if (unit_article.article_id == article.id) {
                    relinkable_article = unit_article
                }
            })

            this.$swal({
                html: 'This article is currently linked to page <strong>' + relinkable_article.page + '</strong>. Are you sure you want to relink it to page <strong>' + this.page.page + '</strong>?',
                showCancelButton: true,
                confirmButtonText: 'Relink Article',
                confirmButtonColor: '#E67E22',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.unlinkArticle(relinkable_article, 1)
                    this.linkArticleToPage(article)

                    this.show_article_picker_modal = false
                }
            })
        },
        unlinkItemFromPage(item, page) {
            this.axios.post('/api/units/remove_item_from_page/' + item.unit_page_slot_id, {is_moved: 1})
                .then(() => {
                    if (page.articles) {
                        let index = _.findIndex(page.articles, {id: item.id})
                        page.articles.splice(index, 1)
                    }
                })
                .finally(() => {
                    this.getArticles()
                })
        },
        moveItemToDifferentPage(transfer_data, page) {
            if (page !== transfer_data.page.page) {
                if (!_.find(page.articles, {article_id: transfer_data.article.article_id})) {
                    this.axios.post('/api/units/add_article/' + this.unit.id, {
                        article_id: transfer_data.article.article_id,
                        page: page.page,
                        language: this.publication.language
                    })
                        .then(() => {
                            this.unlinkItemFromPage(transfer_data.article, transfer_data.page)
                        })
                        .finally(() => {
                            this.getArticles()
                        })
                }
            }
        },
        hideArticlePicker() {
            this.show_article_picker_modal = false

            this.type = null
        },
        hideCopyTeModal() {
            this.show_copy_te_modal = false
        }
    }
}
</script>
